import { gql } from "@apollo/client";

// Get Service Provider Details (for purchase page and all service pages)
export const GET_SERVICE_PROVIDER = gql`
  query GetServiceProvider($identifier: String!) {
    service_provider(identifier: $identifier) {
      id
      name
      identifier
      description
      website_url
      logo_url
      is_active
      metadata

      active_pricings {
        id
        service_name
        service_description
        original_price
        discounted_price
        discount_percentage
        gst_percent
        currency
        is_active
        validity_days
        duration_minutes
        show_discount_percentage

        # Calculated pricing fields
        effective_price              # Final price that user pays (including GST)
        total_amount                 # Final amount including GST (what user pays)
        base_amount_excluding_gst    # Base amount without GST (for subtotal display)
        discount_amount              # Amount saved due to discount
        gst_amount                   # GST amount
        has_discount                 # Whether this pricing has a discount
      }
    }
  }
`;

// Payment initiation mutation
export const INITIATE_SERVICE_PROVIDER_PURCHASE = gql`
  mutation InitiateServiceProviderPurchase($input: InitiateServiceProviderPurchaseInput!) {
    initiate_service_provider_purchase(input: $input) {
      purchase {
        id
        transaction_id
        total_amount
        payment_status
        original_price
        gst_amount
      }
      payment_form_html
      errors
    }
  }
`;

// Get my service purchases
export const GET_MY_SERVICE_PURCHASES = gql`
  query GetMyServicePurchases($filter: ServicePurchaseFilterInput, $status: String, $limit: Int, $offset: Int) {
    service_purchases(filter: $filter, status: $status, limit: $limit, offset: $offset) {
      id
      service_name
      provider_name
      duration_minutes
      purchased_date_formatted
      expires_date_formatted
      purchased_price_formatted
      is_active_and_valid
      is_expired
      days_until_expiry
      has_external_session
      status

      service_provider_pricing {
        id
        service_name
        original_price
        effective_price
        validity_days
        duration_minutes
      }

      user_purchase {
        id
        transaction_id
        total_amount
        purchased_at
        payment_status
      }
    }
  }
`;